module.exports = __webpack_public_path__ + "static/media/Mereoleona-Script.c3ab9145.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Mereoleona-Script.woff2
// module id = 2146
// module chunks = 53